export default "__VITE_ASSET__DsNAs$sv__"